<template>
  <div>
    <div class="modal" :class="isActive? 'is-active': ''">
      <div class="modal-background"></div>
      <div class="modal-content">
        <slot></slot>
      </div>
      <button @click="close" class="modal-close is-large" aria-label="close"></button>
      </div>
  </div>
</template>

<script>
export default {
  props: ['isActive'],
  methods: {
    close() {
      this.$emit('done');
    },
  },
};
</script>
